import { render, staticRenderFns } from "./peoplehome.vue?vue&type=template&id=5916fe78&scoped=true&"
import script from "./peoplehome.vue?vue&type=script&lang=js&"
export * from "./peoplehome.vue?vue&type=script&lang=js&"
import style0 from "./peoplehome.vue?vue&type=style&index=0&id=5916fe78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916fe78",
  null
  
)

export default component.exports